module.exports = __webpack_public_path__ + "img/pause.114a9ebe.png";